import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-empty-placeholder',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div>
      <mat-icon svgIcon="empty" [inline]="true"></mat-icon>
    </div>
    <div *ngIf="text">
      {{ text }}
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 3rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyPlaceholderComponent {
  @Input() text?: string;
}
